import Cookies from 'js-cookie';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import api from 'app/shared/utils/api';

const AppActions = {
    updateApp(data) {
        return dispatch => dispatch({
            type: DispatchConstants.UPDATE_APP,
            payload: data,
        });
    },
    screenDimensionChange(screenWidth) {
        return dispatch => dispatch({
            type: DispatchConstants.SCREEN_DIMENSION_CHANGE,
            payload: { screenWidth, isScreenSizeComputed: true },
        });
    },
    setServerSideRedirect(url) {
        return dispatch => dispatch({
            type: DispatchConstants.UPDATE_APP,
            payload: {
                serverSideRedirectUrl: url,
            },
        });
    },
    transitionTo(url) {
        return (dispatch) => {
            // do transition
            window.router.transitionTo(url);

            // dispatch must specify a type
            return dispatch({
                type: DispatchConstants.TRANSITION_TO,
                payload: {},
            });
        };
    },
    getIp(skipClientProxy) {
        return dispatch => dispatch(api.users.ip(skipClientProxy));
    },
    updateLocation(url) {
        return (dispatch) => {
            window.router.updateLocation(url);

            // dispatch must specify a type
            return dispatch({
                type: DispatchConstants.UPDATE_LOCATION,
                payload: {},
            });
        };
    },
    initializeFeatureFlags(featureFlags) {
        return {
            type: DispatchConstants.INITIALIZE_FEATURE_FLAGS,
            payload: featureFlags,
        };
    },
    updateFeatureFlag(feature, featureValue) {
        // Keep store and cookies in sync
        Cookies.set(feature, featureValue);
        return ({
            type: DispatchConstants.UPDATE_FEATURE_FLAG,
            payload: { feature, featureValue },
        });
    },
};

export default AppActions;
